import MDBox from "components/MDBox";
import DefaultSortInfoCard from "examples/Cards/InfoCards/DefaultInfoCard/DefaultSortInfoCard";
import React from "react";
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";

const Statistics = ({ data }) => {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  return (
    <>
      <MDBox>
        <Grid container alignItems="center" spacing={2}>
          <Grid item md={4} xs={12}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="book_online"
              title="Total Voilators"
              value={`${data.totalVoilators || 0}`}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="real_estate_agent"
              title="Notice Issued"
              value={`${data.totalNoticeIssued || 0}`}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultSortInfoCard
              color={sidenavColor}
              icon="settings_account_box"
              title="Voided"
              value={`${data.totalVoided || 0}`}
            />
          </Grid>
        </Grid>
      </MDBox>
    </>
  );
};

export default Statistics;
